import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import Card from '@/views/dashboard/_components/card/card.vue'
import RankingTable from '../online-control-zone/_components/ranking-table.vue'
import type { RankingTableColumn } from '../types'
import { formatTimeStamp } from '@/utils/time'
import { WarningInfomationService, List } from '@/views/dashboard/notice-manage/warning-information-log/warning-infomation-log.service'
import { warningLogDisplayText } from '@/utils/warning-log-display'


export default /*#__PURE__*/_defineComponent({
  __name: 'realtime-virus-alert-panel',
  setup(__props) {

const { t, te, locale } = useI18n()
const router = useRouter()
const injector = useReflectiveInjector([WarningInfomationService])
const warningService = injector.get(WarningInfomationService)

const loading = ref(false)
const rawList = ref<List[]>([])

const tableRows = computed(() =>
  rawList.value.map((row) => {
    void locale.value
    const ts = row.create_time ?? row.alert_time
    return {
      ...row,
      time: ts != null ? formatTimeStamp(Number(ts), 'YYYY-MM-DD HH:mm') : '--',
      computer_name: row.computer_name || '--',
      user_mark: row.user_mark || '--',
      group_name: row.group_name || '--',
      alert_msg: warningLogDisplayText(t, te, row),
    }
  }),
)

const columns = computed<RankingTableColumn[]>(() => {
  void locale.value
  return [
    { prop: 'time', label: t('noticeManage.time'),  columnOpt: { showOverflow: true } },
    { prop: 'alert_msg', label: t('noticeManage.alertMsg'),  columnOpt: { showOverflow: true } },
    { prop: 'computer_name', label: t('listColumns.computerName'), columnOpt: { showOverflow: true } },
    { prop: 'user_mark', label: t('listColumns.userMark'),  columnOpt: {showOverflow: true } },
    { prop: 'group_name', label: t('listColumns.groupName'), columnOpt: { showOverflow: true } },
  ]
})

function goWarningLog () {
  router.push({ path: '/dashboard/warning-log', query: { alert_type: '2' } })
}

async function load () {
  loading.value = true
  try {
    const res = await warningService.getList({
      group_id: -1,
      alert_type: 2,
      page: 1,
      limit: 5,
    })
    rawList.value = res.list || []
  } catch {
    rawList.value = []
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  void load()
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(Card, {
    size: "second",
    class: "realtime-virus-alert-panel",
    style: {"height":"100%","box-sizing":"border-box","display":"flex","flex-direction":"column"},
    title: _ctx.$t('overviewZone.realtimeVirusAlertCardTitle'),
    "on-view-more": goWarningLog,
    "view-more-text": _ctx.$t('commonPage.viewAll'),
    "view-more-button-type": "text"
  }, {
    titleAfter: _withCtx(() => [
      _createVNode(_component_el_tag, {
        size: "small",
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('overviewZone.approvalListRecentFiveTag')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _withDirectives(_createVNode(RankingTable, {
        "hide-rank": "",
        data: tableRows.value,
        columns: columns.value
      }, null, 8, ["data", "columns"]), [
        [_directive_loading, loading.value]
      ])
    ]),
    _: 1
  }, 8, ["title", "view-more-text"]))
}
}

})